export default __webpack_public_path__ + "static/media/github.164d6380.svg";